// Keep requests within NotificationsController::MAX_COUNT_SPACES so every
// membership gets a badge, including accounts belonging to more than 50 spaces.
const MAX_COUNT_SPACES = 50

type SpaceId = string | number

export async function loadSpaceNotificationCounts(
    spaceIds: SpaceId[],
    fetchBatch: (ids: SpaceId[]) => Promise<Record<string, number> | null>,
    fetchOne: (id: SpaceId) => Promise<number>,
    applyCount: (id: SpaceId, count: number) => void,
): Promise<void> {
    for (let offset = 0; offset < spaceIds.length; offset += MAX_COUNT_SPACES) {
        const batch = spaceIds.slice(offset, offset + MAX_COUNT_SPACES)
        const counts = await fetchBatch(batch).catch(() => null)
        await Promise.all(
            batch.map(async id => {
                // An omitted space may no longer be a membership; do not fetch
                // it again or overwrite its badge with an invented zero.
                if (counts) {
                    if (counts[id] != null) applyCount(id, counts[id])
                } else {
                    try {
                        applyCount(id, await fetchOne(id))
                    } catch (error) {
                        console.error('Failed to load notification count:', error)
                    }
                }
            }),
        )
    }
}
